import { render, staticRenderFns } from "./TransferenciaExpurgo.vue?vue&type=template&id=5024cfe9&"
import script from "./TransferenciaExpurgo.vue?vue&type=script&lang=js&"
export * from "./TransferenciaExpurgo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports